"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftSubquestionIdsForRepetition = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const shiftSubquestionIdsForRepetition = (n, originalNode, form, repIndex, count, by
// eslint-disable-next-line max-params
) => {
    if (n.repetitionIndex > repIndex) {
        const repetitionAncestorId = `${originalNode.questionId}_${n.repetitionIndex + by}`;
        const oldId = n.nodeId;
        n.nodeId =
            n.type === FormQuestionType_1.default.REPETITION
                ? repetitionAncestorId
                : `${repetitionAncestorId}_${n.questionId}`;
        n.parentNodeId = n.parentNodeId.split(n.repetitionAncestorId).join(repetitionAncestorId);
        n.repetitionAncestorId = repetitionAncestorId;
        n.repetitionIndex = n.repetitionIndex + by;
        form.answers[n.nodeId] = form.answers[oldId];
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete form.answers[oldId];
        form.questions[n.nodeId] = n;
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete form.questions[oldId];
    }
    n.totalRepetitions = count + by;
};
exports.shiftSubquestionIdsForRepetition = shiftSubquestionIdsForRepetition;
exports.default = exports.shiftSubquestionIdsForRepetition;
